var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useEffect, useState } from "react";
import { Dialog } from "../../Dialog";
import { caseCreation } from "./api";
import config from "../../../assests/config";
import { styled } from "@mui/system";
const StyleWrapper = styled("div")(({ theme }) => {
    return {
        whiteSpace: 'pre',
        [theme.breakpoints.down(426)]: {
            whiteSpace: 'normal',
        }
    };
});
export const ChangeProgram = (props) => {
    var _a, _b;
    const [open, setOpen] = useState(props.modal);
    useEffect(() => {
        setOpen(props.modal);
    }, [props.modal]);
    const Content = useCallback(() => (React.createElement("p", { style: { wordWrap: "break-word" } }, dialogText[open])), [open]);
    const dialogText = {
        "Change Program": "You can submit a request to change your membership program. Our Member Services team will get in touch with you at the earliest and guide you through the process.",
        Cancel: config.headings[`${(_a = props === null || props === void 0 ? void 0 : props.changeProgram) === null || _a === void 0 ? void 0 : _a.AppName}_ChangeProgram`],
        Proceed: "Your request has been submitted.",
        ChangeProgramMsg: config.headings.INNOVATION_ChangeProgram,
    };
    const proceedPrgrm = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const _c = props.changeProgram, { url: URL } = _c, request = __rest(_c, ["url"]);
            yield caseCreation({
                URL,
                data: request,
            });
            setOpen("Proceed");
        }
        catch (error) {
            setOpen("");
            return props.setChangeProgram("");
        }
    }), []);
    const updateChangePrgm = useCallback((btn) => {
        if (btn.label === "Cancel") {
            return setOpen(btn.label);
        }
        else if (btn.label === "Ok") {
            setOpen("");
            return props.setChangeProgram("");
        }
        else if (btn.label === "Proceed") {
            return proceedPrgrm();
        }
        else {
            setOpen("");
            return props.setChangeProgram("");
        }
    }, []);
    if (!open)
        return null;
    return (React.createElement(React.Fragment, null, ((_b = props === null || props === void 0 ? void 0 : props.changeProgram) === null || _b === void 0 ? void 0 : _b.AppName) !== "INNOVATION" ? (React.createElement(Dialog, { key: open, body: Content, title: "Message", show: Boolean(open), handleCallback: updateChangePrgm, buttons: dialogButtons[open] })) : (React.createElement(Dialog, { key: open, show: Boolean(open), body: () => React.createElement(StyleWrapper, null,
            React.createElement("p", null, config.headings.INNOVATION_ChangeProgram)), title: "Message", CloseIcon: true, buttons: [
            {
                label: "Ok",
                size: "large",
                variant: "text",
                type: "button",
                className: "Ok",
            },
        ], handleCallback: updateChangePrgm }))));
};
const dialogButtons = {
    "Change Program": [
        {
            variant: "contained",
            label: "Proceed",
            size: "medium",
        },
        {
            variant: "contained",
            label: "Cancel",
            size: "medium",
        },
    ],
    Cancel: [
        {
            variant: "contained",
            label: "Ok",
            size: "medium",
        },
    ],
    Proceed: [
        {
            variant: "contained",
            label: "Ok",
            size: "medium",
        },
    ],
};
